import React from 'react'

import classNames from 'classnames'

import { useModalContext } from '../context'
import { Button } from '@/Atomic/Molecules/Button'

interface HeaderProps {
  children?: React.ReactNode
  title?: string
  className?: string
}

export const Header: React.FC<HeaderProps> = ({
  children,
  title,
  className,
}) => {
  const { onClose } = useModalContext()
  return (
    <div className={classNames('o-modal-header', className)}>
      <div className="o-modal-header-title">
        {children ??
          (title ? <h3 className="o-modal-title">{title}</h3> : null)}
      </div>
      <Button
        aria-label="Close"
        title="Close"
        variant="icon"
        icon="cross"
        onClick={onClose}
      />
    </div>
  )
}
